var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMegaphone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 20 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 6.04v4h-2v-4Zm-5-3.35v9.19A20.94 20.94 0 0 0 3 8.03a1 1 0 1 1 0-2 23.6 23.6 0 0 0 12-3.34M3 4.05a3 3 0 1 0 0 6c.45 0 .9 0 1.34.06l1.73 4.29 1.86-.74-1.3-3.24c4.84 1 8.37 3.62 8.37 4.61h2V.06L15 0c-.31.98-5.73 4.05-12 4.05",
  className: "icon-megaphone_svg__cls-1"
})));
export default SvgIconMegaphone;